
// @ is an alias to /src
import { DimssaButton, ButtonState } from "@/components/shared/dimssa-button.vue";
import { Component, Vue, Prop } from "vue-property-decorator";
import * as Model from "@gigalot/data-models";
import { v4 as uuidv4 } from "uuid";
import lodash from "lodash";
const Subscriber = require("@jetblack/graphql-reconnect-client");
import { createClient } from "@/helpers/graphql-ws-rtc-adapter";
import ReplayEditDialog from "@/components/ReplayEditDialog.vue";
import BreadcrumbTrail from "@/components/BreadcrumbTrail.vue";
import { homeBreadcrumbs } from "@/utils/breadcrumbs";

@Component({
  components: {
    ReplayEditDialog,
    DimssaButton,
    BreadcrumbTrail,
  },
})
export default class FeedPlan extends Vue {
  @Prop(Boolean) replay: boolean = false;
  manualEntry = false;
  FPdialog = false;
  notifications = false;
  sound = true;
  widgets = false;
  MoveDialog = false;
  name = "feedPlan";
  loading = true;
  dialog = false;
  _editedItem: any = undefined;
  rationPlan: Model.RationPlan = new Model.RationPlan();
  selectedRationPlan?: Model.RationPlan = new Model.RationPlan();
  rationPlans: Model.RationPlan[] = [];
  feedPlans: Model.FeedingPlan = new Model.FeedingPlan();
  selectedFeedPlan: Model.FeedingPlanItem[] = [];
  selected?: Model.FeedingPlanItem;
  noteDraft: string = "";
  lotDescriptionDraft: string = "";
  lotNoteDraft: string = "";
  toFeedPlanItem?: Model.FeedingPlanItem;
  customFeeders: Model.CustomFeeder[] = [];
  page = 1;
  snack = false;
  snackColor = "";
  snackText = "";
  errorText = "";
  errorDialog = false;
  ownerRequiredDialog = false;
  configuration: { feedPlanningOwnerRequired?: boolean } = {};
  tableKey = 0;
  tableHeight = 700;
  scrollLockActive = false;
  prevBodyOverflow = "";
  prevHtmlOverflow = "";
  search = "";
  date = "2012-01-01";
  genders = ["Male", "Female", "Mix"];
  customFooterProps = {
    itemsPerPageOptions: [10, 20, 50, 100, 200, -1],
  };
  headers = [
    {
      text: "Kraal",
      value: "kraalId",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
      width: 90,
    },
    {
      text: "Ration",
      value: "currentRation",
      cellClass: "feed-plan-ration-cell",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
      width: 280,
    },
    {
      text: "Kraal Days",
      value: "projectedDaysInFeedlot",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
      width: 100,
    },
    {
      text: "Animal #",
      value: "numberAnimals",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
      width: 80,
    },
    {
      text: "Owner",
      value: "owner",
      align: "center",
      sortable: true,
      filterable: false,
      divider: true,
      width: 100,
    },
    {
      text: "Lot number",
      value: "lotDescription",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
      width: 90,
    },
    {
      text: "Lot note",
      value: "lotNote",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
      width: 90,
    },
    {
      text: "Incoming Week",
      value: "incomingWeek",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
      width: 80,
    },
    {
      text: "Gender",
      value: "gender",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
      width: 120,
    },
    {
      text: "Kraal Mass",
      value: "kraalAverageMass",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
      width: 80,
    },
    {
      text: "Kraal Date",
      value: "kraalDate",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
      width: 110,
    },
    {
      text: "2nd Implant Date",
      value: "implant2Date",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
      width: 130,
    },
    {
      text: "Slaughter Date",
      value: "proposedSlaughterDate",
      align: "center",
      sortable: true,
      filterable: true,
      divider: true,
      width: 120,
    },
    {
      text: "Notes",
      value: "notes",
      align: "center",
      sortable: false,
      filterable: false,
      divider: true,
    },
    {
      text: "Ration Plan",
      value: "rationPlan",
      width: 520,
    },
  ];

  rule1 = [
    (v: any) => {
      if (v > 500) return "Max 500 days!";
      if (v < 20) return "Min 20 days!";
      return v ? true : "Must contain value";
    },
  ];

  rule2 = [
    (v: any) => {
      if (v < 0) return "Animal must be positive";
      return v ? true : "Must contain value";
    },
  ];

  updateTableHeight() {
    this.$nextTick(() => {
      const tableRef = this.$refs.feedPlanTable as Vue | undefined;
      if (!tableRef || !tableRef.$el) return;
      const tableEl = tableRef.$el as HTMLElement;
      const wrapperEl = tableEl.querySelector(".v-data-table__wrapper") as HTMLElement | null;
      const footerEl = tableEl.querySelector(".v-data-footer") as HTMLElement | null;
      const rect = (wrapperEl ?? tableEl).getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const footerHeight = footerEl ? footerEl.getBoundingClientRect().height : 0;
      const bottomPadding = 8;
      const nextHeight = Math.max(240, Math.floor(viewportHeight - rect.top - footerHeight - bottomPadding));
      if (nextHeight !== this.tableHeight) {
        this.tableHeight = nextHeight;
      }
    });
  }

  disablePageScroll() {
    if (this.scrollLockActive) return;
    const body = document.body;
    const html = document.documentElement;
    this.prevBodyOverflow = body.style.overflow;
    this.prevHtmlOverflow = html.style.overflow;
    body.style.overflow = "hidden";
    html.style.overflow = "hidden";
    this.scrollLockActive = true;
  }

  restorePageScroll() {
    if (!this.scrollLockActive) return;
    document.body.style.overflow = this.prevBodyOverflow || "";
    document.documentElement.style.overflow = this.prevHtmlOverflow || "";
    this.scrollLockActive = false;
  }

  mounted() {
    this.$store.dispatch("user/addFirebaseCallback", this.getFeedPlans);
    this.$store.dispatch("user/addFirebaseCallback", this.getCustomFeeders);
    this.$store.dispatch("user/addFirebaseCallback", this.getFeedPlansSocket);
    this.nowTimer = setInterval(() => {
      this.nowMs = Date.now();
    }, 60000);
    window.addEventListener("resize", this.updateTableHeight);
    this.updateTableHeight();
    if (!this.replay) this.disablePageScroll();
  }
  get today() {
    return Date.toString();
  }

  destroyed() {
    if (this.graphQLUnsubscribe) {
      this.graphQLUnsubscribe();
    }
    if (this.graphQLSubscriber) {
      this.graphQLSubscriber();
    }
    if (this.nowTimer) {
      clearInterval(this.nowTimer);
      this.nowTimer = undefined;
    }
    window.removeEventListener("resize", this.updateTableHeight);
    this.restorePageScroll();
  }

  urlws = "wss://pi.gigalot.systems:7778/api/ws";
  options = {};

  get subscriptions() {
    // Older replay recordings lack type; the read-only replay view does not use it.
    return `subscription($guid:String!) {${this.replay ? "replay" : ""}feedPlan(guid:$guid){
          typename
          guid
          FeedingPlanItems {
            guid
            kraalId
            kraalGuid
            currentRation { guid
            ration 
            colour
            rationGuid
            startDate
            days
            variable
               blendPlanGuid
              blendFromGuid
              blendToGuid
              ${this.replay ? "" : "type"}
            }
            sequence
            projectedDaysInFeedlot
            numberAnimals
            owner
            incomingWeek
            gender
            kraalAverageMass
            kraalAverageMassFloat
            kraalDate
            implant2Date
            proposedSlaughterDate
            rationPlanGuid
            time
            notes
            lotDescription
            lotNote
            rationPlan{
              guid
              ration
              rationGuid
              startDate
              days
              variable
              colour
                 blendPlanGuid
              blendFromGuid
              blendToGuid
              ${this.replay ? "" : "type"}
            }
          }    
        }
    }`;
  }

  variables = { guid: this.$store.state.user.location.guid };
  operationName = null;

  graphQLSubscriber: any = undefined;
  graphQLUnsubscribe: any = undefined;
  nowMs = Date.now();
  nowTimer: ReturnType<typeof setInterval> | undefined = undefined;

  async getFeedPlansSocket() {
    if (this.$store.state.useP2PConn) {
      await this.getOnlineFeedPlansSocket();
    } else {
      await this.getOnsiteFeedPlansSocket();
    }
  }

  handleFeedPlanSubscription(error: any, data?: any) {
    if (error) {
      this.$store.state.wsConnected = false;
      if (error?.event?.type !== "close") {
        this.$store.state.wsDialogVisible = true;
        const details = error.details ?? error;
        const errors = Array.isArray(details) ? details : [details];
        this.errorText = errors.map((entry: any) => entry.message || String(entry)).join("; ");
        this.errorDialog = true;
        console.error("Feed plan subscription failed", details);
      }
      return;
    }
    // The onsite client sends null error and data when the subscription completes.
    if (data == null) return;
    const plan = this.replay ? data.replayfeedPlan : data.feedPlan;
    if (!plan) return;
    this.$store.state.wsDialogVisible = false;
    this.$store.state.wsConnected = true;
    this.feedPlans = plan;
    if (!this.replay && this._editedItem) {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Data saved";
      this._editedItem._send = "receivedByServer";
    }
    this.loading = false;
  }

  async getOnsiteFeedPlansSocket() {
    this.graphQLSubscriber = Subscriber.graphQLReconnectingSubscriber(
      this.urlws,
      this.options,
      (error: any, subscribe: any) => {
        if (error) {
          this.handleFeedPlanSubscription(error);
          return;
        }
        if (!subscribe) return;
        try {
          this.graphQLUnsubscribe = subscribe(this.subscriptions, this.variables, this.operationName, this.handleFeedPlanSubscription);
        } catch (err) {
          this.handleFeedPlanSubscription(err);
        }
      },
      15000,
      3,
      "graphql-ws"
    );
  }

  async getOnlineFeedPlansSocket() {
    const variables = { guid: this.$store.state.user.location.guid, user: this.$store.state.user.user.uid };
    try {
      const client = createClient();
      if (!client) {
        this.handleFeedPlanSubscription(new Error("Feed plan connection is unavailable."));
        return;
      }
      this.graphQLUnsubscribe = client.subscribe(
        { query: this.subscriptions, variables },
        {
          next: (message: any) => this.handleFeedPlanSubscription(message.errors?.length ? message.errors : undefined, message.data),
          error: (error: any) => this.handleFeedPlanSubscription(error),
          complete: () => this.handleFeedPlanSubscription(undefined, undefined),
        }
      );
    } catch (err) {
      this.handleFeedPlanSubscription(err);
    }
  }

  // forceRerender() {
  //   let pageHolder = this.page;
  //   console.log(pageHolder);
  //   this.tableKey += 1;
  //   this.page = pageHolder;
  //   console.log(pageHolder);
  // }

  chooseRationPlan(item: any) {
    if (this.replay) return;
    this.dialog = true;
    let rationPlan = lodash.find(this.rationPlans, { guid: item.rationPlanGuid });
    if (rationPlan) this.selectedRationPlan = rationPlan;
    this.selected = item;
  }

  getRationName(guid: string) {
    let rationplan = lodash.find(this.rationPlans, { guid: guid });
    if (rationplan) return rationplan.name;
  }

  displayMoveDialog() {
    this.MoveDialog = true;
  }
  lookupOwner(owner: string) {
    //owner could be guid or string.. Do lookup of guid. If not found just return string
    let ownerslookup = lodash.find(this.customFeeders, { guid: owner });
    if (ownerslookup) {
      return ownerslookup.name;
    } else return owner;
  }
  async moveSelectedKraal() {
    if (this.replay) return;
    //display confirmation dialog
    let toItem = -1;
    if (this.toFeedPlanItem) {
      toItem = lodash.findIndex(this.feedPlans.FeedingPlanItems, { kraalId: this.toFeedPlanItem.kraalId });
    }

    if (toItem > -1) {
      //copy existing kraal parameters to new kraal moved to... ie the plan and ration etc.
      Object.assign(this.memento, this.selectedFeedPlan[0]);
      if (this.memento) {
        let ex_guid = this.feedPlans.FeedingPlanItems[toItem].guid;
        let kraalGuid = this.feedPlans.FeedingPlanItems[toItem].kraalGuid;
        let kraalId = this.feedPlans.FeedingPlanItems[toItem].kraalId;
        let sequence = this.feedPlans.FeedingPlanItems[toItem].sequence;

        this.feedPlans.FeedingPlanItems[toItem] = lodash.clone(this.memento);

        this.feedPlans.FeedingPlanItems[toItem].guid = ex_guid;
        this.feedPlans.FeedingPlanItems[toItem].kraalGuid = kraalGuid;
        this.feedPlans.FeedingPlanItems[toItem].kraalId = kraalId;
        this.feedPlans.FeedingPlanItems[toItem].sequence = sequence;

        this.selectedFeedPlan[0].numberAnimals = 0;
        this.selectedFeedPlan[0].owner = "";
        this.selectedFeedPlan[0].kraalAverageMass = 0;

        //Move cribscore to new kraal also
        let json = await this.$store.dispatch(
          "graphQl",
          {
            gql: `mutation moveCribScore($guid: String!, $fromKraal: String!, $toKraal: String!) {
            moveCribScore(guid:$guid, fromKraal: $fromKraal,toKraal: $toKraal) 
          }`,
            variables: {
              guid: this.$store.state.user.location.guid,
              fromKraal: this.selectedFeedPlan[0].kraalId,
              toKraal: this.feedPlans.FeedingPlanItems[toItem].kraalId,
            },
          },
          { root: true }
        );

        console.log(json);
      }
    }
    //  this.forceRerender();
    this.save(this.selectedFeedPlan[0]);
    this.save(this.feedPlans.FeedingPlanItems[toItem]);
    this.MoveDialog = false;
  }

  clearSelectedKraal() {
    this.$store.commit("popup/displayYesNo", {
      message: `Are you sure you want to clear the feed plan for kraal ${this.selectedFeedPlan[0].kraalId}`,
      yesAction: () => {
        this.selectedFeedPlan[0].numberAnimals = 0;
        this.selectedFeedPlan[0].owner = "";
        this.selectedFeedPlan[0].kraalAverageMass = 0;
        this.save(this.selectedFeedPlan[0]);
      },
    });
    //display confirmation dialog

    //make kraal clear? I don't know what that means to the system
  }

  manageSelectedPlan() {
    if (this.selectedFeedPlan && this.selectedFeedPlan.length) {
      this.chooseRationPlan(this.selectedFeedPlan[0]);
    }
  }

  editSelectedKraal() {
    this.open(this.selectedFeedPlan[0]);
    this.FPdialog = true;
    //show full page edit screen
  }

  getDays(kraalDate: string) {
    let kDate = this.moment(kraalDate);
    let nDate = this.moment(Date.now());
    let days = nDate.diff(kDate, "days");
    return ++days;
  }

  getRationStepDay(planItem: Model.FeedingPlanItem, step: any): number {
    const totalDays = Math.max(0, Number(step?.days) || 0);
    const startDate = step?.startDate ?? this.deriveRationStepStartDate(planItem, step);
    if (!totalDays || !startDate) {
      return 0;
    }

    const now = this.moment(this.nowMs).startOf("day");
    const start = this.moment(startDate).startOf("day");
    const endExclusive = start.clone().add(totalDays, "days");

    if (now.isBefore(start)) {
      return 0;
    }
    if (now.isSameOrAfter(endExclusive)) {
      return totalDays;
    }

    return Math.min(totalDays, now.diff(start, "days") + 1);
  }

  deriveRationStepStartDate(planItem: Model.FeedingPlanItem, step: any): number | undefined {
    if (!planItem?.kraalDate || !Array.isArray((planItem as any)?.rationPlan) || !step?.guid) {
      return undefined;
    }

    const planSteps = (planItem as any).rationPlan as any[];
    const stepIndex = planSteps.findIndex((candidate) => candidate?.guid === step.guid);
    if (stepIndex < 0) {
      return undefined;
    }

    let offsetDays = 0;
    for (let i = 0; i < stepIndex; i++) {
      offsetDays += Number(planSteps[i]?.days) || 0;
    }

    return this.addDays(offsetDays, planItem.kraalDate).getTime();
  }

  getRationStepDaysLabel(planItem: Model.FeedingPlanItem, step: any): string {
    const totalDays = Math.max(0, Number(step?.days) || 0);
    const unit = totalDays === 1 ? "day" : "days";
    return `${totalDays} ${unit} (${this.getRationStepDay(planItem, step)})`;
  }

  getWeekNumber(d: number) {
    let e = new Date(d);
    let f = e.getTime();
    let dayNum = e.getUTCDay() || 7;
    e.setUTCDate(e.getUTCDate() + 4 - dayNum);
    let yearStart = new Date(Date.UTC(e.getUTCFullYear(), 0, 1));
    return Math.ceil(((e.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);
  }

  updateDates(plan: Model.FeedingPlanItem, adjustedLatterRations: boolean = false) {
    let variable = false;
    let subtractedDays = 0;
    let addedDays = 0;
    let totalDays = 0;
    //1 Add up all days of all rations to find how many days left for variable ration

    if (adjustedLatterRations) {
      totalDays = 0;
      for (let i = 0; i < plan.rationPlan.length; i++) {
        totalDays = totalDays + plan.rationPlan[i].days;
      }

      //adjust projected Days
      plan.projectedDaysInFeedlot = totalDays;
    }
    totalDays = 0;
    for (let i = 0; i < plan.rationPlan.length; i++) {
      if (!plan.rationPlan[i].variable) totalDays = totalDays + plan.rationPlan[i].days;
    }
    plan.proposedSlaughterDate = this.addDays(plan.projectedDaysInFeedlot, plan.kraalDate).getTime();
    if (plan.kraalDate) {
      plan.incomingWeek = this.moment(plan.kraalDate).week();

      //4 Adjust implant date
      plan.implant2Date = new Date(plan.kraalDate + 1000 * 60 * 60 * 24 * 55).getTime(); //TODO: Implant days is magic number 55
    }

    //  addedDays = 0;

    // 2 Adjust variable days to take up remaining days
    for (let i = 0; i < plan.rationPlan.length; i++) {
      if (plan.rationPlan[i].variable === true) {
        variable = true;
        plan.rationPlan[i].days = plan.projectedDaysInFeedlot - totalDays;
      }

      //Move all dates on by adding previous added days
      if (plan.kraalDate) plan.rationPlan[i].startDate = this.addDays(addedDays, plan.kraalDate).getTime();
      addedDays += plan.rationPlan[i].days;
    }

    //3 Moves the current ration plan to the one that has been activated after this date.
    for (let i = 0; i < plan.rationPlan.length; i++) {
      if (plan.rationPlan[i].startDate < Date.now()) {
        plan.currentRation = plan.rationPlan[i];
      }
    }
  }
  //helpers

  getKraalType(guid: string) {
    let kraals = this.$store.getters[`storage`]().Kraals as Model.Kraal[];
    let kraal = lodash.find(kraals, { guid: guid });
    if (kraal) return kraal.kraalType;
  }

  addDaysDate(date: Date, days: number) {
    date = new Date(date.valueOf());
    date.setDate(date.getDate() + days);
    return date;
  }

  addDays(days: number, date?: number) {
    var nuDate = new Date();
    if (date) {
      nuDate = new Date(date.valueOf());
      nuDate.setDate(nuDate.getDate() + days);
    }
    return nuDate;
  }
  save(item?: any) {
    if (item) {
      this.open(item);
    }
    //update server with changes

    let thisguid = this.open_guid;
    if (this.configuration.feedPlanningOwnerRequired && !String(thisguid?.owner || "").trim()) {
      this.ownerRequiredDialog = true;
      return;
    }
    if (!thisguid?.owner) {
      thisguid.owner = "";
    }
    this.updateDates(thisguid, false);
    this.updateServer(thisguid);
  }

  saveRationSpecific() {
    //update server with changes
    let thisguid = this.open_guid;
    this.updateDates(thisguid, true);
    this.updateServer(thisguid);
  }

  cancelRationPlanChange(selectedRationPlan: any) {
    this.dialog = false;
    let feedplanitem = lodash.findIndex(this.feedPlans.FeedingPlanItems, { guid: selectedRationPlan.guid });
    if (feedplanitem > -1) {
      this.feedPlans.FeedingPlanItems[feedplanitem] = lodash.cloneDeep(this.memento);
    }
    this.selectedFeedPlan[0] = lodash.cloneDeep(this.memento);
    // this.forceRerender();
  }

  acceptRationPlanChange(selectedRationPlan: any) {
    if (this.selected) {
      //1
      let rationPlan: Model.RationScheduleItem[] = [];
      let addedDays = 0;
      //generate  ration schedule items
      selectedRationPlan.rationItems.forEach((plannedRation: any) => {
        let rationPlanItem: Model.RationScheduleItem = {
          days: plannedRation.defaultDays,
          guid: Date.now() + "_" + uuidv4(),
          ration: plannedRation.ration,
          rationGuid: plannedRation.rationGuid,
          startDate: this.addDaysDate(new Date(), addedDays).getTime(),
          variable: plannedRation.variable,
          colour: plannedRation.colour,
          type: plannedRation.type,
          blendFromGuid: plannedRation.blendFromGuid,
          blendPlanGuid: plannedRation.blendPlanGuid,
          blendToGuid: plannedRation.blendToGuid,
        };
        rationPlan.push(rationPlanItem);
        addedDays += plannedRation.defaultDays;
      });

      this.selected.rationPlanGuid = selectedRationPlan.guid;
      this.selected.rationPlan = rationPlan;
      // this.updateDates(this.selected);
      this.open_guid = this.selected;

      this.save();
    }
    this.dialog = false;
  }

  saveRation(thisguid: any) {
    this.$store.commit("popup/displayYesNo", {
      message: "Are you sure you want to change the ration?",
      yesAction: () => {
        this.updateServer(thisguid);
      },
      noAction: () => {
        this.cancel(thisguid);
      },
    });
  }

  onNotesOpen(item: any) {
    this.open(item);
    const notes = item?.notes;
    if (Array.isArray(notes)) {
      this.noteDraft = notes.join("\n");
    } else if (typeof notes === "string") {
      this.noteDraft = notes;
    } else {
      this.noteDraft = "";
    }
  }

  onNotesSave(item: any) {
    item.notes = this.noteDraft;
    this.save(item);
  }

  onNotesCancel(item: any) {
    this.noteDraft = "";
    this.cancel(item);
  }

  onNotesClose() {
    this.noteDraft = "";
    this.close();
  }

  onLotDescriptionOpen(item: any) {
    this.open(item);
    const value = item?.lotDescription;
    this.lotDescriptionDraft = value !== undefined && value !== null ? String(value) : "";
  }

  onLotDescriptionSave(item: any) {
    item.lotDescription = this.lotDescriptionDraft;
    this.save(item);
  }

  onLotDescriptionCancel(item: any) {
    this.lotDescriptionDraft = "";
    this.cancel(item);
  }

  onLotDescriptionClose() {
    this.lotDescriptionDraft = "";
    this.close();
  }

  onLotNoteOpen(item: any) {
    this.open(item);
    const value = item?.lotNote;
    this.lotNoteDraft = value !== undefined && value !== null ? String(value) : "";
  }

  onLotNoteSave(item: any) {
    item.lotNote = this.lotNoteDraft;
    this.save(item);
  }

  onLotNoteCancel(item: any) {
    this.lotNoteDraft = "";
    this.cancel(item);
  }

  onLotNoteClose() {
    this.lotNoteDraft = "";
    this.close();
  }

  memento: any = {};
  open_guid?: any = {};

  cancel(item: any) {
    if (item) {
      let feedplanitem = lodash.findIndex(this.feedPlans.FeedingPlanItems, { guid: item.guid });
      if (feedplanitem > -1) {
        this.feedPlans.FeedingPlanItems[feedplanitem] = lodash.cloneDeep(this.memento);
      }
      this.selectedFeedPlan[0] = lodash.cloneDeep(this.memento);
      //restore memento cause canceled
      // this.forceRerender();
      this.open_guid = {};
      this.snack = true;
      this.snackColor = "blue lighten-1";
      this.snackText = "Canceled";
    }
  }
  open(guid?: any) {
    Object.assign(this.memento, guid);
    this.open_guid = guid;
  }
  close() {
    this.open_guid = {};
  }

  getRowClass(item: any) {
    const classes = ["feed-plan-table__row"];
    if (item && (item as any)._send === "failedToSend") {
      classes.push("feed-plan-table__row--error");
    }
    if (this.selectedFeedPlan && this.selectedFeedPlan.some((selected) => selected && selected.kraalId === item?.kraalId)) {
      classes.push("feed-plan-table__row--selected");
    }
    return classes.join(" ");
  }

  getRations(feedPlanItem: Model.FeedingPlanItem): Model.RationScheduleItem[] {
    return feedPlanItem.rationPlan;
  }

  getColor(ration: string, feedPlanItem?: any) {
    if (feedPlanItem) {
      let index = this.rationPlans.findIndex((r) => {
        return r.guid === feedPlanItem.rationPlanGuid;
      });
      if (index > -1) {
        let index2 = this.rationPlans[index].rationItems.findIndex((s) => {
          return s.ration === ration;
        });
        if (index2 > -1) return this.rationPlans[index].rationItems[index2].colour;
        else return "";
      } else return "";
    } else {
      let index = this.rationPlan.rationItems.findIndex((r) => {
        return r.ration === ration;
      });
      if (index > -1) {
        return this.rationPlan.rationItems[index].colour;
      } else return "";
    }
  }
  normalizeColor(color?: string) {
    if (!color) {
      return "grey darken-1";
    }
    if (typeof color === "string") {
      return color.toLowerCase();
    }
    return `${color}`.toLowerCase();
  }

  getDate(date: any) {
    return new Date(date + 7200000).toISOString().substr(0, 10);
  }

  setDate(date: any) {
    return this.moment(date).valueOf() + 7200000; //TODO: GMT+2 = 7200000
  }
  get moment() {
    return this.$store.state.moment;
  }

  async getCustomFeeders() {
    try {
      let gql = Model.gql.queries.customFeeders;
      let json = await this.$store.dispatch("graphQl", { gql, variables: { guid: this.$store.state.user.location.guid } });
      this.customFeeders = json.data.customFeeders.filter((m: any) => m.active === true);
    } catch (err) {
      console.log("getCustomFeeders -> error: " + err);
      this.errorDialog = true;
      this.errorText = `Error downloading from server: ${err}`;
    }
  }
  get totalKraals(): number {
    return this.feedPlans && this.feedPlans.FeedingPlanItems
      ? this.feedPlans.FeedingPlanItems.filter((fp) => {
          if (fp.numberAnimals > 0) return fp;
        }).length
      : 0;
  }
  get totalAnimals(): number {
    if (!(this.feedPlans && this.feedPlans.FeedingPlanItems)) {
      return 0;
    }
    return this.feedPlans.FeedingPlanItems.reduce((total: number, feedPlanItem: any) => {
      const count = Number(feedPlanItem && feedPlanItem.numberAnimals) || 0;
      return total + count;
    }, 0);
  }

  get selectedAnimalCount(): number {
    if (!this.selectedFeedPlan || this.selectedFeedPlan.length === 0) {
      return 0;
    }
    return this.selectedFeedPlan.reduce((total: number, feedPlanItem: any) => {
      const count = Number(feedPlanItem && feedPlanItem.numberAnimals) || 0;
      return total + count;
    }, 0);
  }

  get themeClass(): string {
    return this.$store.state.lightDarkMode;
  }

  get breadcrumbs() {
    return homeBreadcrumbs({ text: "Feed Planning", disabled: true });
  }

  async getFeedPlans() {
    try {
      console.log("FeedPlans()");
      this.loading = true;
      let gql = `query($guid:String!){
        FeedPlan(guid:$guid){
          typename
          guid
          FeedingPlanItems {
            guid
            kraalId
            kraalGuid
            currentRation { 
              guid
              ration 
              colour
              rationGuid
              startDate
              days
              variable
              blendPlanGuid
              blendFromGuid
              blendToGuid
              type
            }
            sequence
            projectedDaysInFeedlot
            numberAnimals
            owner
            incomingWeek
            gender
            kraalAverageMass
            kraalAverageMassFloat
            kraalDate
            implant2Date
            proposedSlaughterDate
            rationPlanGuid
            time
            notes
            lotDescription
            lotNote
            rationPlan{
              guid
              ration
              rationGuid
              startDate
              days
              variable
              colour
              blendPlanGuid
              blendFromGuid
              blendToGuid
              type
            }
          }    
        }
          RationPlans(guid:$guid) {
          typename
          guid
          creationDate
          name
          rationItems{
            typename
            guid
            ration
            rationGuid
            defaultDays
            colour
            order
            variable
               blendPlanGuid
              blendFromGuid
              blendToGuid
              type
          }
        }
        GenderType(guid:$guid) {
          typename
          guid
          genderType
          active
        }
        Configuration(guid:$guid)
           RationPlan(guid:$guid) {
          typename
          guid
          creationDate
          rationItems{
            typename
            guid
            ration
            rationGuid
            defaultDays
            colour
            order
            variable
               blendPlanGuid
              blendFromGuid
              blendToGuid
              type
          }
        }
      }`;

      let json = await this.$store.dispatch("graphQl", { gql, variables: { guid: this.$store.state.user.location.guid } });
      if (!this.replay) this.feedPlans = json.data.FeedPlan;
      this.rationPlan = json.data.RationPlan;
      this.rationPlans = json.data.RationPlans;
      this.configuration = json.data.Configuration ? JSON.parse(json.data.Configuration) : {};
      if (json.data.GenderType.length > 0)
        this.genders = json.data.GenderType.map((g: Model.GenderType) => {
          return g.genderType;
        });
    } catch (err) {
      console.log("getFeedPlans -> error: " + err);
      this.errorDialog = true;
      this.errorText = `Error downloading from server: ${err}`;
    }
    this.loading = false;
  }

  async updateServer(editedItem?: any) {
    if (this.replay) return;
    if (editedItem) {
      this._editedItem = editedItem;
      try {
        console.log("updateServer()");

        this._editedItem._send = "sending";

        // this.forceRerender();
        let copy = lodash.cloneDeep(editedItem);
        delete copy._send;
        let guid_string = JSON.stringify(editedItem);
        let json = await this.$store.dispatch(
          "graphQl",
          {
            gql: `mutation AddFeedingPlan($guid: String!, $input: FeedingPlanItemInput!, $user: String) {
            addFeedPlan(guid:$guid, input: $input, user: $user)
          }`,
            variables: { guid: this.$store.state.user.location.guid, input: copy, user: JSON.stringify({ userId: this.$store.state.user.user.uid, userName: this.$store.state.user.user.displayName || "", userEmail: this.$store.state.user.user.email || "" }) },
          },
          { root: true }
        );
        // this.forceRerender();
      } catch (err) {
        console.log(err);
        this._editedItem._send = "failedToSend";
        // this.forceRerender();
        this.errorDialog = true;
        this.errorText = `Error saving to server: ${err} ${editedItem.kraalId}`;

        throw err;
      }
    }
  }
}
